import { Flex, Heading } from "@chakra-ui/react";
import { useFlags } from "flagsmith/react";
import { FormikProps } from "formik";
import { FormikSearchSelect } from "src/components/Inputs/SearchSelect";
import { RuleTip } from "src/scenes/orgAdmin/formTemplates/RulesTab/FormEngineRuleDrawer/RuleTip";
import { FormEngineRuleFormData } from "src/scenes/orgAdmin/formTemplates/RulesTab/FormEngineRuleDrawer/schemas";
import {
  School,
  TagType,
} from "src/scenes/orgAdmin/formTemplates/RulesTab/FormEngineRuleDrawer/shared";
import * as GQL from "src/types/graphql";
import { DynamicSiblingRule } from "./DynamicSiblingRule";
import { QuestionRule } from "./QuestionRule";
import { SelectTags } from "./SelectTags";

export type Props = {
  formik: FormikProps<FormEngineRuleFormData>;
  questions: GQL.GetFormEngineRuleQuestions_form_template_by_pk_sections_questions[];
  boundaries: any[];
  tags: TagType[];
  schools: School[];
};
export const AutoTag: React.FC<Props> = ({
  formik,
  questions,
  boundaries,
  tags,
  schools,
}) => {
  const flags = useFlags(["geographic-tagging-rule"]);
  const enableAddressQuestions = flags["geographic-tagging-rule"].enabled;

  return (
    <Flex
      direction="column"
      border="1px solid"
      borderColor="gray.200"
      borderRadius="md"
    >
      {/* start tag selection section */}
      <SelectTags formik={formik} tags={tags} />
      {/* end tag selection section */}
      {/* start tag condition section */}
      <Flex
        direction="column"
        gap="0.5rem"
        p="1rem"
        borderTop="1px solid"
        borderTopColor="gray.200"
        borderTopRadius="0"
      >
        <Heading as="h4" size="sm">
          How would you like to apply this tag?
        </Heading>
        {/* start trigger condition section */}

        <FormikSearchSelect
          name="configuration_type"
          label="When should the tag be applied"
          placeholder="Select a condition"
          items={[
            {
              key: "DYNAMIC_SIBLING",
              label: "There's at least one sibling",
            },
            {
              key: "FORM_QUESTION",
              label: "Based on student answer",
            },
          ]}
        />

        {formik.values.configuration_type === "DYNAMIC_SIBLING" && (
          <DynamicSiblingRule formik={formik} schools={schools} />
        )}
        {formik.values.configuration_type === "FORM_QUESTION" && (
          <QuestionRule
            formik={formik}
            questions={questions}
            boundaries={boundaries}
            schools={schools}
            enableAddressQuestions={enableAddressQuestions}
          />
        )}
      </Flex>
      {/* end tag condition section */}
      {/* start tag disclaimer section */}
      {formik.values.rule_type && <RuleTip formik={formik} />}
      {/* end tag disclaimer section */}
    </Flex>
  );
};
